import i18n from '@/utils/i18n';
import React from 'react';
import ThumbsUpImage from '@assets/icons/thumbs-up-image.svg';
import { EmptyStateCard } from './empty-state-card';
import { Text } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  onButtonPress: () => void;
}

export const CreateOrderOnboardingCard: React.FC<Props> = ({
  onButtonPress,
}) => {
  const theme = useTheme();
  return (
    <EmptyStateCard
      buttonProps={{
        children: i18n.t('place_an_order'),
        onPress: onButtonPress,
        trackingData: {
          name: 'onboarding_card.create_order_button',
        },
      }}
      iconProps={{
        accentFill: theme.colors.accent,
        fill: theme.colors.primary,
      }}
      ImageComponent={ThumbsUpImage}
      showBackground={false}
    >
      <Text style={TYPOGRAPHY.cardMessageText}>
        {i18n.t('onboarding_card.create_order_message')}
      </Text>
    </EmptyStateCard>
  );
};
